import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get baseUnit
export const getBaseUnit = createAsyncThunk("baseUnit/getBaseUnit", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getBaseUnit({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all baseUnit
export const getAllBaseUnit = createAsyncThunk("baseUnit/getAllBaseUnit", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllBaseUnit();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("baseUnit/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("baseUnit/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("baseUnit/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageBaseUnit({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create baseUnit
export const createBaseUnit = createAsyncThunk("baseUnit/createBaseUnit", async (data, { rejectWithValue }) => {
  const { name, shortForm, displayOrder, conversionRate, parent, isActive } = data;
  try {
    const body = JSON.stringify({ name, shortForm, displayOrder, conversionRate, parent, isActive });
    const { data } = await API.createBaseUnit(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateBaseUnit = createAsyncThunk("baseUnit/updateBaseUnit", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, shortForm, displayOrder, conversionRate, parent, isActive } = values;
  try {
    const body = JSON.stringify({ name, shortForm, displayOrder, conversionRate, parent, isActive });
    const { data } = await API.updateBaseUnit(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("baseUnit/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
